// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module--container--1A45E","title":"style-module--title--hSzRU"};